import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { NoSuchPage } from "./NoSuchPage";
import { BrandVariants, createDarkTheme, createLightTheme, FluentProvider, Theme } from "@fluentui/react-components";
import { BrowserRouter, Route, Routes } from "react-router";
import "./App.css";
import OuterTemplate from "./templates/OuterTemplate";
import InnerTemplate from "./templates/InnerTemplate";
import DashboardPage from "./pages/DashboardPage";
import CustomersPage from "./pages/CustomersPage";
import DropboxesPage from "./pages/DropboxesPage";
import ProductsPage from "./pages/ProductsPage";
import SalesPage from "./pages/SalesPage";
import SettingsPage from "./pages/SettingsPage";
import VendorsPage from "./pages/VendorsPage";

let container = document.getElementById( "app" )!;
let root = createRoot( container );

const omnivend: BrandVariants = {
  10:  "#260900",
  20:  "#481200",
  30:  "#6B1B00",
  40:  "#8C2500",
  50:  "#AC3000",
  60:  "#C83B00",
  70:  "#E24800",
  80:  "#F55300",
  90:  "#FF6200",
  100: "#FF7000",
  110: "#FF8000",
  120: "#FF9100",
  130: "#FFA21F",
  140: "#FFB547",
  150: "#FFC875",
  160: "#FFDBA3"
};

const lightTheme: Theme = {
   ...createLightTheme( omnivend ), 
};

const darkTheme: Theme = {
   ...createDarkTheme( omnivend ), 
};

darkTheme.colorBrandForeground1 = omnivend[ 110 ];
darkTheme.colorBrandForeground2 = omnivend[ 120 ];

let theme = lightTheme;
if( window.matchMedia && window.matchMedia( "(prefers-color-scheme: dark)" ).matches )
    theme = darkTheme;

if( window.localStorage.getItem( "theme" ) )
    theme = window.localStorage.getItem( "theme" ) === "dark" ? darkTheme : lightTheme;

document.body.style.backgroundColor = theme.colorNeutralBackground1;

root.render(
  <StrictMode>
    <FluentProvider theme={ theme }>
      <BrowserRouter>
        <Routes>
          <Route element={<OuterTemplate />}>
            <Route element={<InnerTemplate />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/sales" element={<SalesPage />} />
              <Route path="/customers" element={<CustomersPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/vendors" element={<VendorsPage />} />
              <Route path="/dropboxes" element={<DropboxesPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<NoSuchPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </FluentProvider>
  </StrictMode>
);
